/* utopiaagriculture */
var strBase = "販売時間となりましたら下記「カートに追加する」ボタンからご購入いただけます。<br>";
strBase = strBase + '※1度にご購入可能な箱数は6箱までとなっております。<br>';
strBase = strBase + '※<a href = "/blogs/news/hui-yuan-idgong-tong-hua-falsegoan-nei" style = "text-decoration: none;" target = "break" >会員ID共通化のご案内</a> ';


// 表示メッセージと時刻パターン
var HomeMessagesData = {
    "soon": {
        "textMessage": "まもなく20時より販売をいたします。<br>" + strBase,
        "btnMessage": "まもなく販売開始",
        "timeStart": "19", // 9
        "timeEnd": "19", // 9
    },
    "sale": {
        "textMessage": strBase,
        "btnMessage": "",
        "timeStart": "20", // 10
        "timeEnd": "20", // 23
    },
    "preparation": {
        "textMessage": strBase,
        "btnMessage": "商品準備中",
        "timeStart": "0", // 0
        "timeEnd": "18", // 8
    },
    "soldout": {
        "textMessage": "今週の製造分の販売は終了いたしました。<br>たくさんのご注文をありがとうございました。<br>次回は、", //〇月〇日の20時から販売いたします。
        "btnMessage": "完売",
        "timeStart": "20",
        "timeEnd": "",
    }
};

// 売り切れ商品
var notElement = document.getElementsByClassName('not-quantity');

$(function () {
    if(1 == 1){
        cartCheck(null, null, null);
        return 0;
    }

    var nextMonth = 1;
    var nextDay = 1;

    var btnSoldoutText = document.getElementsByClassName('js-soldout-text');
    var btnSoldoutTextArray = Array.from(btnSoldoutText);
    var btnMessage = HomeMessagesData.soldout.btnMessage;	// ボタンメッセージ
    // var textMessage = HomeMessagesData.soldout.textMessage;	// 画面上メッセージ


    var date = new Date(); // '2022/02/18'

   // var date = new Date('2024/12/18 21:02');// '2022/03/05 20:01'

    var hour = date.getHours();	// 時
    var minute = date.getMinutes();	// 分
    var dayOfWeek = date.getDay();	// 曜日(数値)　　0が日曜

    var nowHour = parseInt(hour);
    var nowMinutes = parseInt(minute);
    var nowWeekday = dayOfWeek;


    // console.log("============================== 現在の日時");
    // console.log(date);

    if (5 == nowWeekday || 6 == nowWeekday || 0 == nowWeekday) {
        if ((5 == nowWeekday || 6 == nowWeekday) && (nowHour == 19 || (nowHour == 20 && nowMinutes == 0) || (nowHour == 20 && nowMinutes == 1))) {
            // [19:00 - 20:00] まもなく販売開始
            btnMessage = HomeMessagesData.soon.btnMessage;
            //    textMessage = HomeMessagesData.soon.textMessage;

        } else if ((5 == nowWeekday || 6 == nowWeekday) && (nowHour <= 18)) {
            // [0:00 - 19:00] 商品準備中
            btnMessage = HomeMessagesData.preparation.btnMessage;
            //    textMessage = HomeMessagesData.preparation.textMessage;

        } else if ((nowHour >= 20 && 5 == nowWeekday) || 6 == nowWeekday || 0 == nowWeekday) {
            // 20:01 以降の場合の場合、売切れにする。
            btnMessage = HomeMessagesData.soldout.btnMessage;

            if ($(".product-form__cart-submit").length == notElement.length) {
                var youbo = "(金)";
                if (5 == nowWeekday) {
                    // 金曜の場合は、次の日付
                    date.setDate(date.getDate() + 1);
                    youbo = "(土)";
                } else {
                    // 土曜日の場合は、次週の金曜の日付
                    date.setDate(date.getDate() + 6);
                }

                nextMonth = date.getMonth() + 1;
                nextDay = date.getDate();

                //    textMessage = HomeMessagesData.soldout.textMessage + nextMonth + "月" + nextDay + "日" + youbo + "の20時から販売いたします。";

            } else {
                //     textMessage = HomeMessagesData.sale.textMessage;
            }
        }

    } else {

        // 月 Mon, 火 Tue, 水 Wed, 木 Thu, 金曜日 Fri(販売日), 土曜日 Sat(販売日), 日 Sun
        if (1 == nowWeekday) {
            date.setDate(date.getDate() + 4);
        }
        if (2 == nowWeekday) {
            date.setDate(date.getDate() + 3);
        }
        if (3 == nowWeekday) {
            date.setDate(date.getDate() + 2);
        }
        if (4 == nowWeekday) {
            date.setDate(date.getDate() + 1);
        }

        nextMonth = date.getMonth() + 1;
        nextDay = date.getDate();

        // 金・土曜以外は、無条件で、ただいま準備中	
        btnMessage = HomeMessagesData.preparation.btnMessage;
        //   textMessage = "次回販売は、" + nextMonth + "月" + nextDay + "日(金)の20時から販売いたします。<br>" + strBase;
    }

    btnSoldoutTextArray.forEach(function (target) {
        target.textContent = btnMessage;
    });

    for (let i = 0; i < notElement.length; ++i) {
        notElement[i].innerHTML = btnMessage;
    };
    cartCheck(null, null, null);

    //$(".startText span").html(textMessage);


    if (nowHour >= 10) {
        $('.not-quantity.wondersand').html('本日分売り切れ');
        if (3 == nowWeekday) {
           $('.not-quantity.cheesewonder-magazine').html('本日分売り切れ');
        }
    }

    $(".cw_collabo .not-quantity").html("完売");

    $(".not-quantity[href='/products/cheesewonderapplegold']").html("販売期間は終了しました");

    
});

// 単独購入のみ許可する商品ハンドル。
// これらは他商品（他のCHEESE WONDER商品も含む）と同時にカートへ入れられない。
var CW_EXCLUSIVE_HANDLES = ["wondercake"]; // cheesewonder_j_o_collabo は販売終了のため除外
function isCwExclusive(h) {
    return CW_EXCLUSIVE_HANDLES.indexOf(h) !== -1;
}

// 1度にカートへ入れられる箱数の上限。未指定の商品は CW_MAX_BOX_DEFAULT。
var CW_MAX_BOX_BY_HANDLE = { "wondercake": 2, "wondersand": 3 };
var CW_MAX_BOX_DEFAULT = 6;
function cwMaxBox(h) {
    return CW_MAX_BOX_BY_HANDLE[h] || CW_MAX_BOX_DEFAULT;
}

$('.cw_form').submit(function (event) {
    // alert("cw_form");
    var handle = $(this).attr("handle");
    var addType = $(this).attr("add-type");
    var addQuantity = 0;

    if (addType == "list") {
        addQuantity = 1;
    } else if (addType == "item") {

        addQuantity = $(".inputQuantity").val();

    }
    // alert(addQuantity);

    //  event.preventDefault();

    var err = cartCheck(handle, addType, addQuantity);
    // console.log("cw_form=" + err + ", handle=" + handle + ", addType=" + addType);
    if (err != "") {
        return false;

    }
    /*
    if (err == "") {
        return false;

    }*/
    return true;

});

function cartCheck(addhandle, addType, addQuantity) {
    var isVendor = 0;
    var btnSoldoutTextMessage = "";
    var checkQuantity = 0;
    var isSnowsShopper = 0;
    var isSnows = 0;
        
    var isAddCollabo = 0;
    var isAddNotCollabo = 0;

    var isCollabo = 0;
    var isNotCollabo = 0;
    // カート内に、追加しようとしている商品とは別の「単独購入のみ」商品があるか
    var isOtherExclusiveInCart = 0;
    $.ajax({
        type: 'POST',
        url: '/cart.js',
        async: false,
        dataType: 'json'
    }).done(function (data) {

        if (addhandle != null){
            if (isCwExclusive(addhandle)) {
                isAddCollabo = 1;
            }
            if (!isCwExclusive(addhandle)) {
                isAddNotCollabo = 1;
            }
        }

        for (var k = 0; k <= data.items.length - 1; k++) {
            var handle = data.items[k]["handle"];
            var quantity = data.items[k]["quantity"];
            var vendor = data.items[k]["vendor"];
            var title = data.items[k]["title"];
            if (vendor != "UTOPIA AGRICULTURE STORE") {
                isVendor = 1;
                if (vendor == "snows") {
                    isSnows = 1;
                    if(title.indexOf('ショッパー') !== -1){
                        isSnowsShopper = 1;
                    }else{
                        isSnowsShopper = 0;
                    }
                }
            }else{
                if (isCwExclusive(handle)) {
                    isCollabo = 1;
                    // addhandle が null のとき（ページ読み込み時のチェック）は
                    // 「追加しようとしている商品」が存在しないので比較しない。
                    // 比較すると、カート内の限定品自身が「別の限定品」と誤判定される。
                    if (addhandle != null && handle != addhandle) { isOtherExclusiveInCart = 1; }
                }
                if (!isCwExclusive(handle)) {
                    isNotCollabo = 1;
            }
            }
            // console.log("addhandle:" + addhandle + ", handle:" + handle + ", isCollabo:" + isCollabo);
            // alert("addhandle:" + addhandle + ", handle:" + handle + ", isCollabo:" + isCollabo);
            if (handle == addhandle) {
                checkQuantity = Number(addQuantity) + Number(quantity);

            }
        }

        // isVendor = 10; // kato デバッグ

        // alert("checkQuantity=" + checkQuantity + ", data.item_count=" + data.item_count + ", addQuantity=" + addQuantity);
        //console.log("checkQuantity=" + checkQuantity + ", data.item_count=" + data.item_count);

        //isCollabo = 0; // kato デバッグ
        //alert("isCollabo=" + isCollabo + ", isAddNotCollabo=" + isAddNotCollabo + ", isAddCollabo=" + isAddCollabo + ", isNotCollabo=" + isNotCollabo );
        // 追加対象の箱数上限（wondercake は2箱、wondersand は3箱、それ以外は6箱）
        var maxBox = cwMaxBox(addhandle);
        if((isCollabo == 1 && isAddNotCollabo == 1) || (isAddCollabo == 1 && isNotCollabo == 1) || isOtherExclusiveInCart == 1){
            btnSoldoutTextMessage = "限定品は他商品と同時購入出来ません。";
        
        }else if (isVendor == 1) {
            // alert(isSnowsShopper + "--" + isSnows);
            if(isSnows == 1 && isSnowsShopper == 1){
                $.ajax({
                  type: 'POST',
                  url: '/cart/clear.js',
                  async: false,
                  dataType: 'json'
                }).done(function (data) {
                });
            }else{
            btnSoldoutTextMessage = "他ブランド商品は購入出来ません。";

            }

        } else if (maxBox <= Number(data.item_count)) {
            btnSoldoutTextMessage = "【数量制限】計" + maxBox + "箱以内としてください。";

        } else if ((maxBox + 1) <= checkQuantity) {
            btnSoldoutTextMessage = "【数量制限】計" + maxBox + "箱以内としてください。";

        }
        // console.log("isVendor=" + isVendor + ", btnSoldoutTextMessage=" + btnSoldoutTextMessage);
        // alert("isVendor=" + isVendor + ", btnSoldoutTextMessage=" + btnSoldoutTextMessage);
        if (btnSoldoutTextMessage != "") {
            $(".product-form__cart-submit").each(function (index, element) {

                handle = $(this).attr("handle");
                if(handle != undefined){
                    if(isCwExclusive(handle) && isAddCollabo == 1){
                $(this).html(btnSoldoutTextMessage);
                var data_id = $(this).attr("submit_id");
                $(this).prop("disabled", "true");
                $(".submit-" + data_id + " span").html(btnSoldoutTextMessage);
                    }
                    if(!isCwExclusive(handle) && isAddNotCollabo == 1){
                        $(this).html(btnSoldoutTextMessage);
                        var data_id = $(this).attr("submit_id");
                        $(this).prop("disabled", "true");
                        $(".submit-" + data_id + " span").html(btnSoldoutTextMessage);
                    }

                }else{
                    $(this).html(btnSoldoutTextMessage);
                    var data_id = $(this).attr("submit_id");
                    $(this).prop("disabled", "true");
                    $(".submit-" + data_id + " span").html(btnSoldoutTextMessage);

                }
            
            });

        }
    }).fail(function () {
    });
    return btnSoldoutTextMessage;
}

